/* eslint-disable @typescript-eslint/indent */
// import { accountUrl } from '@/utils/common/env.constants';
import { Button } from '@pwskills/rachnaui';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { IMappedCourseDetails } from '@/interfaces/courseDescription';
import { encodeSlugUrl, isPwMedharthiDomain } from '@/utils/helper/helperFunction';
import { DOMAIN } from '@/utils/homePage/env.constants.utils';
import { COURSE_PURCHASE_TYPE, CourseTypes } from '@/utils/common/common.constants';
import { GAevent } from '@/utils/firebase.utils';
// import { useUTMParameters } from '@pwskills/rachnaui/hooks';
import { bankCourseIdsArray } from '@/utils/courseDescription/description.constants';
import useIsCourseBought from '@/hooks/useIsCourseBought';
// import { LoginType } from '@/GlobalEnums/enums';
import useUserCourseDetails from '@/store/userCoursesDetails';
import { useUTMParameters } from '@pwskills/rachnaui/hooks';
import { usePWAuthWebSDK } from '@/hooks/usePWAuthWebSDK';
import { sendSkBuyNowClickedEvent, sendSkCtaClickedEvent } from '@/utils/GAEventFunction';
import { AuthEnums } from '@/GlobalEnums/enums';
import Toaster from '../Toaster';
import LeadCapture from '../LeadCapture';
import { LeadCaptureEnquiryType, LeadCaptureType } from '../../../interfaces/leadCapture.enum';
import useUserDetails from '../../../store/userDetails';
import { IOICategoryArray } from './utils';

type Props = {
  classes?: string;
  title?: string;
  slug?: string;
  pageFrom?: string;
  courseId?: string;
  categoryId?: string;
  isFree?: boolean;
  ctaOnCard?: string;
  courseType?: string;
  coursePurchaseType?: string;
  onClick?: (type: string) => void;
  isStickyNavBar?: boolean;
  isDescriptionPage?: boolean;
  disabled?: boolean;
  sectionFrom?: string;
  categoryName?: string;
  planCourses?: any;
  categorySlug?: string;
  buttonText?: string;
  isOnlineDegree?: boolean;
  courseprice?: number;
  discountPercentage?: number;
};

const CardFooterButton2 = (props: Props) => {
  const {
    courseprice,
    title,
    slug,
    pageFrom,
    courseId,
    categoryId,
    isFree,
    ctaOnCard,
    coursePurchaseType,
    courseType,
    onClick,
    isStickyNavBar,
    isDescriptionPage,
    classes = '',
    disabled,
    sectionFrom,
    categoryName,
    planCourses,
    categorySlug,
    buttonText,
    isOnlineDegree = false,
    discountPercentage,
  } = props;
  // const { isLoggedIn } = useContext(UserDetailsContext);
  const router = useRouter();
  const { userCoursesMap } = useUserCourseDetails();
  const [openModal, setOpenModal] = useState(false);
  const [mappedCourseDetails, setMappedCourseDetails] = useState<IMappedCourseDetails>({
    courseId: '',
    courseSlug: '',
    purchasedCourseSlug: '',
    purchasedCourseType: '',
  });
  const [toastMessage, setToastMessage] = useState({ isError: false, message: '' });
  const [openToaster, setOpenToaster] = useState(false);
  // const utmQuery = useUTMParameters();
  // const { triggerFlow, setNextRoute } = useLoginFlowContext();

  // const { user } = useContext(UserDetailsContext);
  const { userDetails: user, userIsLoggedIn: isLoggedIn, isUserPaid } = useUserDetails();
  const userData = user;
  const cName = router.query.courseSlug;
  const [isCourseBought, setIsCourseBought] = useState<boolean>(false);
  const [lessonId, setLessonId] = useState('');
  const [bankCourse, setBankCourse] = useState(false);
  const isDashBoard = router?.pathname?.includes('dashboard');
  const {
    checkIsCourseBought,
    returnLessonId,
    handleMappedCourses,
    isCourseBoughtForPlan,
    planCourseMappedDetails,
    planTypeCourseBought,
  } = useIsCourseBought();
  const utmQuery = useUTMParameters();
  // const getIsCourseBought = async () => {
  //   try {
  //     const courseBoughtResponse: any = await CourseDescription.isCourseBought(courseId as string);
  //     if (courseBoughtResponse?.data) {
  //       setIsCourseBought(true);
  //       setLessonId(courseBoughtResponse?.data?.lessonId);
  //       if (courseBoughtResponse?.data?.courseId) {
  //         setMappedCourseDetails({
  //           courseId: courseBoughtResponse?.data?.courseId,
  //           courseSlug: courseBoughtResponse?.data?.courseSlug,
  //           lessonId: courseBoughtResponse?.data?.lessonId,
  //         });
  //       }
  //     }
  //   } catch (error: unknown) {
  //     setIsCourseBought(false);
  //     // eslint-disable-next-line no-console
  //     console.error((error as IError)?.error);
  //   }
  // };
  const handleDashboardButtonText = () => {
    if (isCourseBought) return 'Enrolled';
    return buttonText;
  };
  const cardFooterText = () => {
    if (IOICategoryArray.includes(categoryId as string)) {
      if (isPwMedharthiDomain() && isCourseBought && isLoggedIn) return 'Continue Learning';
      return 'Apply Now';
    }
    let cardFooterButtonText = '';

    cardFooterButtonText =
      bankCourse && !isCourseBought
        ? 'Register Now'
        : bankCourse && isCourseBought
        ? 'Registered'
        : isCourseBought && isLoggedIn
        ? 'Go to course'
        : isStickyNavBar || isDescriptionPage
        ? coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN
          ? 'Buy now'
          : isFree
          ? 'Enroll Now'
          : isOnlineDegree
          ? 'Enroll Now'
          : 'Buy Now'
        : isFree
        ? 'Enroll Now'
        : ctaOnCard === 'BUY_NOW'
        ? 'Buy Now'
        : 'Get Callback';

    return cardFooterButtonText;
  };

  const sendGAevent = (source: string) => {
    const GAEventData = {
      source,
      ...utmQuery,
    };
    GAevent('sk_login_page_visit', GAEventData);
  };

  const { initApp } = usePWAuthWebSDK({
    sdkProps: {
      themeFor: 'skills',
      onGoogleSignIn: () => {
        // your logic
      },
      googleClientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '',
      cameFrom: AuthEnums.BLOG,
      ctaName: AuthEnums.LOGIN,
      formLocation: pageFrom || 'course_card',
      course_batch_name: title,
      course_batch_slug: slug,
      course_batch_category: categoryName,
      course_batch_id: courseId,
      course_batch_cohort_id: categoryId,
      price: courseprice,
      discount_percentage: discountPercentage,
      is_free: isFree,
    },
    onAuthSuccessCallBack: () => {
      router.push(`/checkout?course_id=${courseId}`);
    },
  });

  const handleClickWithRedirect = (redirectUrl: string) => {
    if (isLoggedIn) {
      router.push(redirectUrl);
      return;
    }
    initApp();
    sendGAevent(cardFooterText());
  };

  const handleScrollToHeroSection = (href: string) => {
    const section = document.getElementById(href);
    const sectionTop = Number(section?.offsetTop) - 60;

    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth',
    });
  };

  // const handleScrollToHeroSection = (href: string) => {
  //   const section = document.getElementById(href);
  //   const sectionTop = Number(section?.offsetTop) - 60;

  //   window.scrollTo({
  //     top: sectionTop,
  //     behavior: 'smooth',
  //   });
  // };

  useEffect(() => {
    if (bankCourseIdsArray?.includes(courseId as string) && courseId) setBankCourse(true);
    if (isLoggedIn) {
      // getIsCourseBought();

      if (coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN && planCourses) {
        setIsCourseBought(isCourseBoughtForPlan(planCourses));
        setMappedCourseDetails(planCourseMappedDetails(planCourses));
      } else {
        setIsCourseBought(checkIsCourseBought(courseId as string));
        setMappedCourseDetails(handleMappedCourses(courseId as string));
      }
      setLessonId(returnLessonId(courseId as string));
    }
  }, [courseId, isLoggedIn, userCoursesMap]);

  const sendGAEvent = (courseName: string, courseID: string, sectionName: string) => {
    GAevent('sk_course_watch', {
      user_id: userData._id,
      user_name: `${userData.firstName} ${userData.lastName}`,
      user_email: userData.email,
      user_phonenumber: `${userData.isdCode} ${userData.phoneNumber}`,
      course_name: courseName,
      course_id: courseID,
      section_name: sectionName,
    });
  };

  const goToPlanSection = (dashboard: boolean) => {
    const section = document.getElementById('plans');
    if (dashboard && section) section.scrollIntoView({ behavior: 'smooth' });
    else {
      const sectionTop = Number(section?.offsetTop) - 60;
      window.scrollTo({
        top: sectionTop,
        behavior: 'smooth',
      });
    }
  };

  const goToMyCourseFunction = () => {
    const sectionParam = sectionFrom ? `&section=${sectionFrom}` : '';

    if (coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN) {
      // coming from description page
      if (planCourses) {
        if (planTypeCourseBought?.purchasedCourseType === CourseTypes.PLACEMENT)
          router.push(
            `${DOMAIN}/learn/career-path/${encodeSlugUrl(
              planTypeCourseBought?.slug || (slug as string)
            )}/${planTypeCourseBought?.courseId}/dashboard?from=${router.asPath}`
          );
        else if (mappedCourseDetails?.lessonId) {
          router.push(
            `${DOMAIN}/learn/course/${encodeSlugUrl(
              planTypeCourseBought?.slug || (slug as string)
            )}/${planTypeCourseBought?.courseId}/lesson/${mappedCourseDetails?.lessonId}?from=${
              router.asPath
            }&clickText=go_to_course&page_from=${pageFrom}${sectionParam}`
          );
        } else if (lessonId) {
          router.push(
            `${DOMAIN}/learn/course/${slug || ''}/${courseId}/lesson/${lessonId}?from=${
              router.asPath
            }&clickText=go_to_course&page_from=${pageFrom}${sectionParam}`
          );
        } else {
          setToastMessage({ isError: true, message: 'Course has not started yet' });
          setOpenToaster(true);
        }
      } else {
        // coming from description page
        const slugUrl = encodeSlugUrl(
          (mappedCourseDetails?.purchasedCourseSlug as string) || title || (slug as string)
        );
        if (mappedCourseDetails?.purchasedCourseType === CourseTypes.PLACEMENT)
          router.push(
            `${DOMAIN}/learn/career-path/${slugUrl}/${courseId}/dashboard?from=${router.asPath}`
          );
        else if (mappedCourseDetails?.lessonId) {
          router.push(
            `${DOMAIN}/learn/course/${slugUrl}/${courseId}/lesson/${mappedCourseDetails?.lessonId}?from=${router.asPath}&clickText=go_to_course&page_from=${pageFrom}${sectionParam}`
          );
        } else if (lessonId) {
          router.push(
            `${DOMAIN}/learn/course/${slugUrl}/${courseId}/lesson/${lessonId}?from=${router.asPath}&clickText=go_to_course&page_from=${pageFrom}${sectionParam}`
          );
        } else {
          setToastMessage({ isError: true, message: 'Course has not started yet' });
          setOpenToaster(true);
        }
      }
    } else if (courseType && courseType === CourseTypes.PLACEMENT)
      router.push(
        `${DOMAIN}/learn/career-path/${slug}/${courseId}/dashboard?from=${router.asPath}&clickText=go_to_course&page_from=${pageFrom}${sectionParam}`
      );
    else if (lessonId)
      router.push(
        `${DOMAIN}/learn/course/${slug}/${courseId}/lesson/${lessonId}?from=${router.asPath}&clickText=go_to_course&page_from=${pageFrom}${sectionParam}`
      );
    else {
      setToastMessage({ isError: true, message: 'Course has not started yet' });
      setOpenToaster(true);
    }
  };

  const handleCourseBtnGAEvent = () => {
    sendGAEvent(cName as string, courseId as string, 'Go to Course Button');
  };

  const handleGAEvent = (clickText: string) => {
    const GAEventData = {
      user_id: user?._id,
      user_type: isLoggedIn ? 'logged_in' : 'logged_out',
      user_category: user?.userType || '',
      click_text: clickText,
      page_name: 'course_description_page',
      category_id: categoryId || '',
      category_name: categoryName || '',
      course_id: courseId || '',
      course_name: title || '',
      courseType: isFree ? 'free' : 'paid',
      // course_type: 'masterclass',
      utm_source: utmQuery?.utm_source || '',
      utm_medium: utmQuery?.utm_medium || '',
      utm_campaign: utmQuery?.utm_campaign || '',
      page_ref: router?.query?.from || '',
    };
    GAevent('sk_course_descrip_action', GAEventData);
  };

  const getPrimaryPlanInfo = () => {
    const primaryPlan = Array.isArray(planCourses) ? planCourses[0] : undefined;
    const pricing = primaryPlan?.pricing;

    const rawPrice = Number(pricing?.IN ?? pricing?.US);
    const rawDiscount = Number(pricing?.discount ?? 0);

    return {
      price: Number.isFinite(rawPrice) ? rawPrice : undefined,
      discount: Number.isFinite(rawDiscount) ? rawDiscount : 0,
      planType: primaryPlan?.planType || primaryPlan?.plan_type || primaryPlan?.type,
      cohortId: primaryPlan?.cohortId || primaryPlan?.cohort_id,
    };
  };

  const triggerBuyNowEvent = (ctaText: string) => {
    if (ctaText.trim().toLowerCase() !== 'buy now') return;

    const planInfo = getPrimaryPlanInfo();
    const resolvedPrice =
      typeof courseprice === 'number' && Number.isFinite(courseprice) && courseprice > 0
        ? courseprice
        : planInfo.price;
    const resolvedDiscount =
      typeof discountPercentage === 'number' && Number.isFinite(discountPercentage)
        ? discountPercentage
        : planInfo.discount;

    sendSkBuyNowClickedEvent({
      userData: user,
      isLoggedIn,
      isUserPaid,
      user_account_type:
        typeof isUserPaid === 'boolean' ? (isUserPaid ? 'Paid' : 'Free') : undefined,
      page_path: router?.pathname,
      page_referrer_name: (router?.query?.from as string) || undefined,
      page_referrer_cta: (router?.query?.clickText as string) || undefined,
      page_referrer_widget_name: (router?.query?.section as string) || undefined,
      click_text: ctaText,
      plan_type: planInfo.planType,
      course_name: title || '',
      course_slug: slug || '',
      course_category: categoryName || '',
      course_id: courseId || '',
      cohort_id: categoryId,
      price: resolvedPrice,
      discount_percentage: resolvedDiscount,
      is_free: !!isFree,
    });
  };

  return cardFooterText() ? (
    <>
      <Button
        disabled={
          (disabled &&
            (cardFooterText() === 'Enroll Now' ||
              cardFooterText() === 'Buy Now' ||
              cardFooterText() === 'Register Now') &&
            coursePurchaseType !== COURSE_PURCHASE_TYPE.PLAN) ||
          (bankCourse && isCourseBought)
        }
        className={
          classes !== ''
            ? classes
            : 'hover:bg-[none] bg-[#E58471] font-extrabold large:!font-bold  h-10 medium:!h-12 !min-w-[50%] !w-full'
        }
        variant="primary"
        onClick={() => {
          if (IOICategoryArray.includes(categoryId as string)) {
            if (isPwMedharthiDomain()) {
              if (isCourseBought && isLoggedIn) {
                goToMyCourseFunction();
                return;
              }

              const returnUrl =
                typeof router.query.returnUrl === 'string'
                  ? `&returnUrl=${encodeURIComponent(router.query.returnUrl)}`
                  : '';
              handleClickWithRedirect(`/checkout?course_id=${courseId || ''}${returnUrl}`);
              return;
            }
            window.open('https://pwioi.com/', '_self');
            return;
          }
          const ctaText = cardFooterText();

          sendSkCtaClickedEvent({
            userData: user,
            isLoggedIn,
            isUserPaid,
            page_path: router?.pathname,
            click_type: 'route',
            click_text: ctaText,
            click_id: `course_card_${ctaText.toLowerCase().replace(/\s+/g, '_')}`,
            click_position: sectionFrom || 'course_card_footer',
            widget_name: sectionFrom || 'course_card',
            page_referrer_cta: (router?.query?.clickText as string) || '',
            page_referrer_widget_name: (router?.query?.section as string) || '',
            course_name: title || '',
            course_slug: slug || '',
            course_category: categoryName || '',
            course_id: courseId || '',
            price: (() => {
              const planInfo = getPrimaryPlanInfo();
              if (
                typeof courseprice === 'number' &&
                Number.isFinite(courseprice) &&
                courseprice > 0
              )
                return courseprice;
              return planInfo.price;
            })(),
            discount_percentage: (() => {
              if (typeof discountPercentage === 'number' && Number.isFinite(discountPercentage))
                return discountPercentage;
              const rawDiscount = Number(planCourses?.[0]?.pricing?.discount ?? 0);
              return Number.isFinite(rawDiscount) ? rawDiscount : 0;
            })(),
            is_free: !!isFree,
          });

          triggerBuyNowEvent(ctaText);

          handleGAEvent(ctaText);
          if (onClick) {
            onClick(ctaText);
          }
          if (isOnlineDegree) {
            handleScrollToHeroSection('category-hero-section');
            return;
          }
          if (isCourseBought && isLoggedIn) {
            goToMyCourseFunction();
          } else if (
            ctaOnCard === 'GET_CALLBACK' &&
            !isFree &&
            !isDescriptionPage &&
            !isStickyNavBar
          ) {
            setOpenModal(true);
          } else if (
            (isDescriptionPage || isStickyNavBar) &&
            coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN
          ) {
            goToPlanSection(isDashBoard);
          }
          // if plan type course scroll to plan section
          else if (coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN) {
            router.push(
              `/${
                categorySlug || 'course'
              }/${slug}/?goToPlanSection=true&source=${pageFrom}&source_position=course_buy_now`
            );
          } else if (isLoggedIn && !isCourseBought) {
            if (pageFrom === 'course_listing') {
              router.push(`/checkout?course_id=${courseId}&source=listing_page`);
            } else {
              router.push(`/checkout?course_id=${courseId}&source=home_page`);
            }
          } else {
            // const newUrl = new URL(`${accountUrl}/login`);
            // newUrl.searchParams.set('domain', window.location.host);
            // newUrl.searchParams.set('redirectUrl', `/checkout?course_id=${courseId}`);
            // newUrl.searchParams.set('position', pageFrom ? 'Nav_Enroll_now' : `enroll_now`);
            // newUrl.searchParams.set('loginType', LoginType.COOKIE);
            // if (utmQuery) {
            //   Object.entries(utmQuery).forEach(([key, value]) => {
            //     newUrl.searchParams.set(key, value as string);
            //   });
            // }
            // window.location.href = newUrl.href;
            // triggerFlow("Buy_Now");
            // setNextRoute(`/checkout?course_id=${courseId}`)
            handleClickWithRedirect(`/checkout?course_id=${courseId}`);
          }
          if (isCourseBought) handleCourseBtnGAEvent();
        }}
        size={isDashBoard ? 'small' : 'medium'}
      >
        {isDashBoard ? handleDashboardButtonText() : cardFooterText()}
      </Button>

      {openModal && (
        <LeadCapture
          courseId={courseId}
          categoryId={categoryId}
          courseName={title}
          categoryName={categoryName}
          leadCaptureType={LeadCaptureType.MODAL}
          modelOpen={openModal}
          setModelOpen={setOpenModal}
          buttonText="Get Connected"
          img="/images/courseDescription/get-in-touch.svg"
          msgLineOne="We Got Your Response."
          msgLineTwo="Our Counsellor will reach out soon"
          type="ConnectWithCounsellor"
          enquiryType={LeadCaptureEnquiryType.GET_CALLBACK}
          enquiryTypeNPF="Get Callback"
          pageName={pageFrom}
        />
      )}

      {openToaster && (
        <Toaster
          open={openToaster}
          setOpen={setOpenToaster}
          text={toastMessage.message}
          variant={toastMessage?.isError ? 'error' : 'success'}
        />
      )}
    </>
  ) : (
    <div />
  );
};

export default CardFooterButton2;
